import React from 'react'
import { useTranslation } from 'react-i18next';
import DataTable2 from '../../../components/AdminTable/DataTable2';

function Report() {
  const { t } = useTranslation();
  const header=[{
    id:1,
    thead1:t("studentDash.report.colTeacherName"),
    thead2: t("studentDash.report.colSubject"),
    thead3:t("studentDash.report.colTotalClasses"),
    thead5:t("studentDash.report.colStatus"),

  }]

  const data = [
    {
      id: 1,
      column1: "Irfan Ahsan",
      column2: "Subject Name",
      column3: "10",
      column4: "---",
    },
    {
      id: 2,
      column1: "Muslim Sheikh",
      column2: "Subject Name",
      column3: "5",
      column4: "---",
      
    },
    {
      id: 3,
      column1: "Muhammad Sohail",
      column2: "Subject Name",
      column3: "2",
      column4: "---",
      
    },
    {
      id: 4,
      column1: "Zohaib Bhai",
      column2: "Subject Name",
      column3: "9",
      column4: "---",
   
    },
    {
      id: 5,
      column1: "Muslim Sheikh",
      column2: "Subject Name",
      column3: "10",
      column4: "---",
     
    },
   
    
  ];



  return (
    <main>
      <DataTable2
      heading={t("studentDash.report.title")}
      SubHeading={t("studentDash.chatMsg.teachers")}
      header={header}
      data={data}/>

      
    </main>
  )
}

export default Report
